import { getDefaultUiState, UiApolloStoreState } from './ui';
import { UserStoreState, getDefaultUserState } from './user';

export interface InitialApolloStoreState {
  ui: UiApolloStoreState;
  me: UserStoreState;
}

const initStore = (): InitialApolloStoreState => ({
  ui: getDefaultUiState(),
  me: getDefaultUserState()
});

export default initStore;
